import React, { useEffect, useState } from 'react';
import Dialog from '@/presentation/reusables/Dialog';
import emailSvg from '../../assets/email.svg';
import phoneSvg from '../../assets/phone.svg';
import ReusableInfo from '@/presentation/reusables/Info';
import { WrapperConfirmDialog } from './styled';
import type { TActionState } from '../../types';

interface IProps {
  actionState: TActionState;
  controllerActionState: (state: Partial<TActionState>) => void;
}

const ConfirmDialog = ({ actionState, controllerActionState }: IProps) => {
  const [isActive, setIsActive] = useState(false);

  const types: any = {
    EMAIL: {
      src: emailSvg,
      title: 'Te enviaremos un código de verificación a este correo.',
      message: '¿Es correcto?'
    },
    PHONE: {
      src: phoneSvg,
      title:
        'Te enviaremos un código de verificación a este número de celular.',
      message: '¿Es correcto este número?'
    },
    DEFAULT: {
      src: '',
      title: '',
      message: ''
    }
  };

  useEffect(() => {
    setIsActive(actionState.action === 'CONFIRM');
  }, [actionState]);

  const handlerCancel = () => {
    controllerActionState({
      action: 'DEFAULT',
      code: ''
    });
  };

  const handlerConfirm = () => {
    controllerActionState({
      action: 'VALIDATION',
      code: 'GENERATE'
    });
  };

  return (
    <Dialog
      handlerButtonA={handlerConfirm}
      handlerButtonB={handlerCancel}
      handlerClose={handlerCancel}
      maxWidth="360px"
      show={isActive}
      styleActions={{ paddingTop: '8px' }}
      textButtonA="Sí, continuar"
      textButtonB="Editar"
      zIndex={1000}
    >
      <WrapperConfirmDialog>
        <img src={types[actionState.input].src} alt="errores" />
        <p>{types[actionState.input].title}</p>
        <p>{actionState.newValue}</p>
        {actionState.input === 'EMAIL' && (
          <ReusableInfo
            style={{ marginTop: '12px' }}
            iconColor="#161D1F"
            textColor="#161D1F"
            text="Recuerda que este correo sirve para modificar tu contraseña."
          />
        )}
        <p>{types[actionState.input].message}</p>
      </WrapperConfirmDialog>
    </Dialog>
  );
};

export default ConfirmDialog;
